import React, { useRef, useState } from 'react';
import { View } from 'react-native';
import styled from 'styled-components/native';
import { useFocus } from 'react-native-web-hooks';
import PropTypes from 'prop-types';
import Text from '../text';
import Colors from '../colors';
const StyledView = styled.View`
  padding: 10px;
`;
const StyledTextInput = styled.TextInput`
  padding: 12px;
  height: ${props => props.height};
  background: ${Colors.lightGray200};
  border: 1px solid;
  border-color: ${props => props.error || props.limitError ? Colors.error400 : Colors.lightGray500};
  box-sizing: border-box;
  border-radius: 4px;
  margin: 2px 0px;
  font-family: Larsseit;
  font-size: 16px;
  font-style: normal;
  outline-color: ${Colors.advanceBlue400};
  color: ${Colors.gray600};
  placeholder-text-color: ${Colors.gray200};
`;
const StyledCounter = styled.View`
  position: absolute;
  right: 20;
  bottom: 20;
`;
export default function TextArea(props) {
  const [text, setText] = useState(props.value);
  const [length, setLength] = useState(0);
  const [limitError, setLimitError] = useState(false);
  const ref = useRef();
  const focused = useFocus(ref);
  return /*#__PURE__*/React.createElement(StyledView, null, /*#__PURE__*/React.createElement(Text.BodyBase, {
    ref: ref,
    color: props.disabled ? Colors.gray200 : props.error || limitError ? Colors.error400 : focused ? Colors.advanceBlue400 : Colors.gray300
  }, props.label), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(StyledTextInput, {
    value: text,
    onChangeText: input => {
      props.onChangeText(input);
      setText(input);

      if (props.characterLimit !== null) {
        setLength(input.length);
        setLimitError(length > props.characterLimit);
      }
    },
    onBlur: props.onBlur,
    placeholder: props.placeholder,
    multiline: true,
    disabled: props.disabled,
    error: props.error,
    ref: ref,
    width: props.width,
    height: props.height,
    limitError: limitError
  }), props.characterLimit !== null && /*#__PURE__*/React.createElement(StyledCounter, null, /*#__PURE__*/React.createElement(Text.BodySmall, {
    color: limitError ? Colors.error400 : Colors.gray300
  }, length, "/", props.characterLimit))), /*#__PURE__*/React.createElement(Text.BodySmall, {
    color: props.disabled ? Colors.gray100 : props.error || limitError ? Colors.error400 : Colors.gray400
  }, props.helper));
}
TextArea.defaultProps = {
  value: '',
  label: '',
  placeholder: 'text',
  disabled: false,
  error: false,
  helper: '',
  height: '172px',
  width: '448px',
  characterLimit: 225,
  onChangeText: () => {},
  onBlur: () => {}
};
TextArea.propTypes = {
  value: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  helper: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
  characterLimit: PropTypes.number,
  onChangeText: PropTypes.func,
  onBlur: PropTypes.func
};
//# sourceMappingURL=text-area.js.map